import React, { Dispatch, SetStateAction } from 'react';
import styled, { css } from '@emotion/native';
import { green } from '@/shared/styles/colors';
import { ProgressBody } from '@/app/onboarding/components/Progress';
import Button from '@/shared/components/Button';
import { H2 } from '@/shared/components/StyledText';
import { useStripe } from '@/services/stripe/StripeProvider';
import { useGetUser } from '@/shared/hooks/useGetUser';
import SentryService from '@/services/sentry/Sentry.service';

interface Props {
  setProgress: Dispatch<SetStateAction<number>>;
}

const AddPayment = ({ setProgress }: Props) => {
  const { user } = useGetUser();
  const { openPaymentMethodSheet } = useStripe();

  const onPressSavePaymentMethod = async () => {
    if (!user?.client?.stripeCustomerId) {
      SentryService.captureError(
        `Client ${user?.client?.id} does not have a Stripe customer id`,
      );
      return;
    }

    const paymentMethod = await openPaymentMethodSheet(
      user?.client?.stripeCustomerId,
    );

    if (paymentMethod) {
      setProgress((prev) => prev + 1);
    }
  };

  return (
    <OuterContainer>
      <StyledTitle>ADD PAYMENT</StyledTitle>
      <ProgressBody>
        You&apos;ll only be charged once your session is complete—no surprises,
        just expert styling on demand.
      </ProgressBody>
      <Button
        variant="primary"
        text="save payment method"
        onPress={onPressSavePaymentMethod}
        customLabelStyle={{ fontSize: 11 }}
        customStyle={buttonStyles}
      />
    </OuterContainer>
  );
};

const OuterContainer = styled.View({
  height: '100%',
  borderRadius: 8,
  justifyContent: 'center',
  alignItems: 'center',
  padding: 16,
});

const StyledTitle = styled(H2)({
  fontSize: 30,
  textTransform: 'uppercase',
  maxWidth: '100%',
  marginBottom: 12,
  color: green,
  textAlign: 'center',
});

const buttonStyles = css({ marginBottom: 12, height: 56, width: 240 });

export default AddPayment;
